<template>
    <v-sheet color="grey lighten-3" class="pa-6">
        <v-row align="start">
            <v-col cols="12" md="4">
                <v-card-title class="pa-0">
                    <v-select v-model="form.price.unit" solo flat hide-details v-bind="{ items: units }" @input="emit" />
                </v-card-title>
            </v-col>
            <v-col cols="12" md="8" class="purchase-amount__form">
                <v-row class="ma-n1">
                    <v-col class="pa-1" cols="12">
                        <v-row class="ma-n1" justify="end" align="center">
                            <v-col class="pa-1" cols="auto">
                                <v-btn icon tile @click="decrease"> <v-icon> mdi-minus </v-icon> </v-btn>
                            </v-col>
                            <v-col class="pa-1" cols="auto">
                                <!-- 수량은 정수만 — min/step 으로 브라우저 단계에서 먼저 막고, emit() 에서 한 번 더 보정한다 -->
                                <v-text-field class="purchase-amount__form__data" v-model="form.count" type="number" min="1" step="1" flat solo hide-details @input="emit" />
                            </v-col>
                            <v-col class="pa-1" cols="auto">
                                <v-btn icon tile @click="increase(1)"> <v-icon> mdi-plus </v-icon> </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="pa-1" cols="12">
                        <v-row class="ma-n1" justify="end" align="center">
                            <template v-for="value in [5, 10, 20, 40]">
                                <v-col class="pa-1" cols="auto" :key="value">
                                    <v-btn x-small @click="increase(value)"> +{{ value }}개 </v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { initNshopOrder, NshopOrderAider } from "@/store/nshop";

/** @typedef {import('@/store/nshop').NshopOrder} NshopOrder */

const units = [
    {
        text: "50,000원권",
        value: 50000,
    },
    {
        text: "30,000원권",
        value: 30000,
    },
    {
        text: "10,000원권",
        value: 10000,
    },
];

export default {
    components: {},
    props: {
        /** @type {import('vue').PropType<NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    data: () => ({
        form: initNshopOrder(),

        units,
    }),
    computed: {
        max() {
            return NshopOrderAider.calcCountMax(this.form);
        },
        // 입력창은 값을 문자열로 돌려준다. 증감 버튼이 "2" + 1 = "21" 처럼
        // 이어붙기가 되지 않도록 항상 이 정수값을 거쳐 계산한다.
        count() {
            let count = Math.floor(Number(this.form.count));
            return Number.isFinite(count) ? count : 0;
        },
    },
    methods: {
        sync() {
            this.form = initNshopOrder(this.value);
            if (this.max < this.form.count) {
                this.form.count = this.max;
                this.emit();
            }
        },
        emit() {
            let { ...form } = this.form;

            ////////////////////////////////////////////////////////////////////
            // 수량은 1 이상의 정수로 고정한다.
            // 입력창이 자유입력이라 "2.4" 같은 값이 그대로 들어올 수 있는데,
            // 이 값은 그대로 발급수량이 되고 상대 쪽은 소수점을 버리고 발급한다.
            // (50,000 x 2.4 = 120,000원 결제 / 5만원권 2장 = 100,000원만 발급)
            // 금액은 이 보정된 수량으로 다시 계산해 화면과 결제액을 일치시킨다.
            ////////////////////////////////////////////////////////////////////
            form.count = Math.floor(Number(form.count));
            if (!Number.isFinite(form.count) || form.count < 1) form.count = 1;
            if (this.max < form.count) form.count = this.max;

            form.price = NshopOrderAider.calcPrice(form);

            this.$emit("input", form);
        },

        decrease() {
            if (this.count <= 1) return;
            this.form.count = this.count - 1;
            this.emit();
        },
        increase(value = 1) {
            this.form.count = this.count + value;
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.purchase-amount {
    &__form {
        &__data {
            max-width: 80px;

            & ::v-deep input {
                text-align: center;

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                &[type="number"] {
                    -moz-appearance: textfield;
                    appearance: textfield;
                }
            }
        }
    }
}
</style>
